<label
  [ngClass]="{ disable: disabled }"
  (mouseenter)="handleMouseEnter()"
  (mouseleave)="handleMouseLeave()"
>
  <input
    type="checkbox"
    [formControl]="control"
    [attr.aria-invalid]="control.invalid"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledBy"
    (focus)="handleFocus()"
    (blur)="handleBlur()"
    #inputRef
  />
  <div
    *pluginsLet="baseColor | contrastColor as iconColor"
    class="checkbox"
    [ngClass]="{ disable: disabled }"
    [ngStyle]="
      generateStyle({
        'border-color':
          !!control.value || inputRef.indeterminate || focused
            ? baseColor
            : borderColor,
        'background-color':
          !!control.value || inputRef.indeterminate ? baseColor : 'transparent',
        'box-shadow': focused ? '0 0 0 0.15rem ' + focusColor : 'none',
      })
    "
  >
    @if (inputRef.checked) {
      @if (icon() === 'times') {
        <icon-cancel [color]="iconColor" />
      } @else {
        <icon-check
          [size]="19"
          [color]="iconColor"
          [iconStyle]="{ strokeWidth: '1.3px', stroke: iconColor }"
        />
      }
    }

    @if (inputRef.indeterminate) {
      <icon-minus [color]="iconColor" />
    }
  </div>
  <span class="content">
    <ng-content />
  </span>
</label>
